import * as React from "react";
import { JobRequest, JobRequestFileCategory } from "gen/clients";
import { LabelValue } from "components/LabelValue/LabelValue";
import { secondsToMinutes } from "utils/dateUtils";

interface Props {
  jobRequest: JobRequest;
}

const TotalDurationLabel: React.FC<Props> = ({ jobRequest }) => {
  const totalDurationInSeconds = React.useMemo(() => {
    const sourceFiles =
      jobRequest.files?.filter(file => JobRequestFileCategory.SOURCE_DOCUMENT === file.category) || [];

    const durations = sourceFiles.map(file => {
      const originalDuration = file.secondsCharged || 0;
      return Math.ceil(originalDuration / 60) * 60;
    });
    return durations.reduce((f1, f2) => f1 + f2, 0);
  }, [jobRequest]);

  if (!totalDurationInSeconds) {
    return <span />;
  }

  return <LabelValue label="Source Media Duration (minutes)" value={secondsToMinutes(totalDurationInSeconds)} />;
};

export { TotalDurationLabel };
